

import React, { useState } from 'react'
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md"
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    cursor: 'pointer'
  },
  label: {
    marginLeft: '5px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#828282',
    fontSize: '28px',
    '@media(max-height: 976px)': {
      fontSize: '18px',
    },
  },
  checked: {
    color: theme.colors.primary
  }
}))

function Checkbox (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ value, setValue ] = useState(props.checked)


  const onCheckboxClick = () => {
    const newValue = !value
    setValue(newValue)
    if (props.onChange) {
      props.onChange(newValue)
    }
  }

  return (
    <View className={styles.root} onClick={onCheckboxClick}>
      { value ? (
        <>
          <div>
            <MdCheckBox size='24px' color={theme.colors.primary} /> 
          </div>
          <span className={`${styles.label} ${styles.checked}`}>{ props.label }</span>
        </>
      ) : (
        <>
          <div>
            <MdCheckBoxOutlineBlank size='24px' color={'#828282'} />
          </div>
          <span className={styles.label}>{ props.label }</span>
        </>
      )
      }
      
    </View>
  )
}

export default Checkbox